var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    baseProfile: "basic",
    fill: "#2583ef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 8.278,
    y: 11.278,
    fill: "#2583ef",
    transform: "rotate(45.001 12.278 12.278)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#36c8f6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a2e4f4",
    d: "M5.439,7.561c-0.586-0.586-0.586-1.536,0-2.121c0.586-0.586,1.536-0.586,2.121,0l1.414-1.414v0 c-1.367-1.367-3.583-1.367-4.95,0s-1.367,3.583,0,4.95L5.439,7.561z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.205e346324ce5fc6209a0d0ec0c3cd12.svg";
export { ForwardRef as ReactComponent };